export default [
    {
        path: '/news',
        name: 'News',
        meta: {
            requiresAuth: true,
            allowRoles: null,
            denyRoles: null,
        },
        components: {
            default: () => import('@views/news/NewsIndex.vue'),
        },
    },
    {
        path: '/news/:id/edit',
        name: 'NewsEdit',
        meta: {
            requiresAuth: true,
            allowRoles: null,
            denyRoles: null,
        },
        props: {
            default: (route) => ({ id: route.params.id }),
        },
        components: {
            default: () => import('@views/news/NewsForm.vue'),
        },
    },
    {
        path: '/news/create',
        name: 'NewsCreate',
        meta: {
            requiresAuth: true,
            allowRoles: null,
            denyRoles: null,
        },
        components: {
            default: () => import('@views/news/NewsForm.vue'),
        },
    },
];
